var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('div',[_c('ophq-loading')],1):_c('div',[_c('h1',[_c('ressource',{attrs:{"code":"titre_page"}})],1),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }